import { render, staticRenderFns } from "./MapPin.vue?vue&type=template&id=0058c668&scoped=true&"
import script from "./MapPin.vue?vue&type=script&lang=js&"
export * from "./MapPin.vue?vue&type=script&lang=js&"
import style0 from "./MapPin.vue?vue&type=style&index=0&id=0058c668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058c668",
  null
  
)

export default component.exports